import { memo } from 'react';

import FieldValue from '@/components/Debug/FieldValue';
import { Props } from '@/components/NestedDataList/types';
import RenderRichText from '@/components/RenderRichText';
import { DataRow } from '@/ui/components/DataList';
import DataList from '@/ui/components/DataList/DataList';
import snakeCaseToTitleCase from '@/utils/snakeToTitleCase';

const NestedDataList = ({ data, convertToHtmlList, sensitive = false }: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderDataRows = (key: string, value: any) => {
    const formattedKey = snakeCaseToTitleCase(key);

    if (!!value && typeof value === 'object' && !Array.isArray(value)) {
      const dataEntries = Object.entries(value);

      return (
        <DataRow
          label={
            <>
              {formattedKey} <span className="text-gray-400">&#123;&#125;</span>
            </>
          }>
          <div className="pl-2 border-l border-gray-200">
            <DataList>
              {!dataEntries.length ? (
                <>No data (empty object)</>
              ) : (
                Object.entries(value).map(([k, value]) => {
                  return <div key={k}>{renderDataRows(k, value)}</div>;
                })
              )}
            </DataList>
          </div>
        </DataRow>
      );
    }

    return (
      <DataRow key={key} label={formattedKey} sensitive={sensitive}>
        {convertToHtmlList?.includes(key) ? (
          <RenderRichText body={value} />
        ) : (
          <FieldValue value={value} fieldKey={key} />
        )}
      </DataRow>
    );
  };

  return (
    <DataList>
      {Object.entries(data).map(([key, value]) => (
        <div key={key}>{renderDataRows(key, value)}</div>
      ))}
    </DataList>
  );
};

export default memo(NestedDataList);
